import React, { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { MapActions, MapContext } from "context/map";
import Button from "components/Button";
import "./index.scss";

const ManageAction = () => {
  const [finish, setFinish] = useState(false);
  const { state, dispatch } = useContext(MapContext);
  const { draw, manageStatus, currentField } = state;

  const finishEditing = () => {
    draw.changeMode("simple_select");
    setFinish(true);
  };

  const saveNewBoundaries = useCallback(() => {
    draw.changeMode("direct_select", { featureId: currentField });

    dispatch({ type: MapActions.SET_CREATE_NEW_FIELD });

    setFinish(false);
  }, [currentField, dispatch, draw]);

  const cancelEditing = () => {
    draw.trash();

    if (currentField) {
      draw.delete(currentField);
      draw.changeMode("draw_polygon");

      dispatch({ type: MapActions.SET_CURRENT_FIELD, value: null });
    } else {
      draw.changeMode("static");

      dispatch({ type: MapActions.SET_MANAGE_STATUS, value: null });
    }
  };

  useEffect(() => {
    if (finish) {
      if (!currentField) {
        toast.error("No field to save!");

        draw.changeMode("draw_polygon");
        setFinish(false);

        return;
      }

      saveNewBoundaries();
    }
  }, [currentField, draw, finish, saveNewBoundaries]);

  if (manageStatus !== "create-boundaries") return null;

  return (
    <div className="manage-action-wrapper">
      <section className="action-container">
        <Button
          label="Finish Editing"
          type="solid"
          color="gray"
          rounded
          onClick={() => {
            finishEditing();
          }}
        />
        <Button
          label="Cancel"
          type="solid"
          color="gray"
          rounded
          onClick={() => {
            cancelEditing();
          }}
        />
      </section>
    </div>
  );
};

export default ManageAction;
